export const APP_VERSION = "2.6.0" 
export const LAST_UPDATE_TC = new Date(2024, 2, 1)
export const LAST_UPDATE_PC = new Date(2024, 2, 1)